import { render, staticRenderFns } from "./CampaignsTable.vue?vue&type=template&id=042e9825&scoped=true"
import script from "./CampaignsTable.vue?vue&type=script&lang=ts"
export * from "./CampaignsTable.vue?vue&type=script&lang=ts"
import style0 from "./CampaignsTable.vue?vue&type=style&index=0&id=042e9825&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042e9825",
  null
  
)

export default component.exports